module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-dec-1-b38bdc9704554c20b0f7b8c17d01f195.png";